export function buildRequestUrl(url: string, params: Record<string, string | number>) {
  let finalUrl = url;
  Object.entries(params).forEach(([key, value]) => {
    finalUrl = finalUrl.replace(`:${key}`, String(value));
  });
  return finalUrl;
}
